(function() {
  'use strict';

  angular.module('cfn').directive('dGridData', function() {
    return {
      restrict: 'A',
      scope: {
        dGridData: '=',
        mappingFunction: '&'
      },
      link: function(scope, elem, attrs) {
        scope.controller = {
          getSelectedRows: function() {
            return scope.mappingFunction({ bookings: scope.dGridData });
          }
        };
      }
    };
  });
})();
